import React from "react";
import { Link } from "react-router-dom";
import { Play, Plus, Check } from "lucide-react";
import { fileImageUrl } from "../lib/api";

export default function MovieCard({ movie, inList, onToggleList, variant = "editorial" }) {
  const img = fileImageUrl(movie.backdrop_path || movie.thumbnail_path);
  const isPoster = variant === "poster";

  return (
    <div
      data-testid={`movie-card-${movie.id}`}
      className={`group relative overflow-hidden rounded-xl border border-white/10 bg-[color:var(--ns-card)] card-hover ${
        isPoster ? "aspect-[2/3]" : "aspect-[16/9]"
      }`}
    >
      <Link to={`/movie/${movie.id}`} className="absolute inset-0">
        {img ? (
          <img
            src={img}
            alt={movie.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-zinc-900" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-100 transition" />
      </Link>

      <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
        {movie.is_4k && (
          <span className="font-mono-mini text-[10px] px-2 py-1 border border-[color:var(--ns-accent)] text-[color:var(--ns-accent)] uppercase tracking-widest">
            4K
          </span>
        )}
        {movie.is_hdr && (
          <span className="font-mono-mini text-[10px] px-2 py-1 border border-white/30 text-white uppercase tracking-widest bg-black/40">
            HDR
          </span>
        )}
        {movie.is_dolby_atmos && (
          <span className="font-mono-mini text-[10px] px-2 py-1 border border-white/30 text-white uppercase tracking-widest bg-black/40">
            Atmos
          </span>
        )}
      </div>

      {movie.rating && movie.rating !== "TP" && (
        <div className="absolute top-3 right-3 flex gap-2">
          <span className="font-mono-mini text-[11px] px-2 py-1 bg-black/80 border border-white/30 text-white uppercase tracking-widest rounded">
            {movie.rating}
          </span>
        </div>
      )}

      {onToggleList && (
        <button
          data-testid={`movie-card-fav-${movie.id}`}
          onClick={(e) => {
            e.preventDefault();
            onToggleList(movie.id);
          }}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/60 border border-white/15 flex items-center justify-center hover:bg-[color:var(--ns-accent)] transition"
          title={inList ? "Retirer de ma liste" : "Ajouter à ma liste"}
        >
          {inList ? <Check size={16} /> : <Plus size={16} />}
        </button>
      )}

      <div className="absolute bottom-0 left-0 right-0 p-4 space-y-1">
        <h3 className="font-display text-xl text-white uppercase leading-tight line-clamp-2">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 text-[11px] font-mono-mini uppercase tracking-widest text-zinc-400">
          <span>{movie.genre}</span>
          <span>•</span>
          <span>{movie.year}</span>
        </div>
      </div>

      <Link
        to={`/movie/${movie.id}`}
        className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
      >
        <span className="w-14 h-14 rounded-full bg-white/95 text-black flex items-center justify-center shadow-xl">
          <Play size={22} fill="currentColor" />
        </span>
      </Link>
    </div>
  );
}
